// Import the functions you need from the SDKs you need

import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue } from "firebase/database";
import styled from 'styled-components';
import './App.css';
import { useEffect, useState } from "react";

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration

// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {

  apiKey: "AIzaSyCogzGEAHHMbIB7wKi3Q21_u2EXCZLo37Y",

  authDomain: "pillbox-7c41a.firebaseapp.com",

  databaseURL: "https://pillbox-7c41a-default-rtdb.firebaseio.com",

  projectId: "pillbox-7c41a",

  storageBucket: "pillbox-7c41a.appspot.com",

  messagingSenderId: "892609465479",

  appId: "1:892609465479:web:7712d005f4af84ac6b3c22"

};



// Initialize Firebase

const app = initializeApp(firebaseConfig);

const db = getDatabase(app);

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`

const Counter = styled.h1`
  font-size: 20rem;
`

function App() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const countRef = ref(db, 'count');
    onValue(countRef, (snapshot) => {
      const data = snapshot.val();
      setCount(data);
    });
  }, [setCount])
  

  return (
    <Container>
      <Counter>{count}</Counter>
    </Container>
  );
}

export default App;
